// extracted by mini-css-extract-plugin
export default {"root":"tooltip_root__2V4ra","container":"tooltip_container__H+C5O"};